import { render } from "./faqQuestionRow.vue?vue&type=template&id=6fe5d54c"
import script from "./faqQuestionRow.vue?vue&type=script&lang=js"
export * from "./faqQuestionRow.vue?vue&type=script&lang=js"

import "./faqQuestionRow.vue?vue&type=style&index=0&id=6fe5d54c&lang=less"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__